export const blogPosts = [
  {
    slug: 'por-que-investir-florida-2025',
    titulo: 'Por que investir na Flórida em 2025?',
    resumo: 'Descubra as vantagens fiscais, crescimento populacional e oportunidades do mercado imobiliário da Flórida para investidores brasileiros.',
    categoria: 'Investimento na Flórida',
    tempoLeitura: '8 min',
    data: '15 de janeiro de 2025',
    imagem: 'https://public.readdy.ai/ai/img_res/9641529f5bea20994abb7b4e06a45cc7.jpg',
    conteudo: 'Conteúdo completo do artigo...',
  },
  {
    slug: 'processo-construcao-casa-florida',
    titulo: 'O processo de construção de uma casa na Flórida',
    resumo: 'Entenda todas as etapas, desde a escolha do terreno até a entrega das chaves, com prazos e custos envolvidos.',
    categoria: 'Construção residencial',
    tempoLeitura: '10 min',
    data: '10 de janeiro de 2025',
    imagem: 'https://readdy.ai/api/search-image?query=Home%20construction%20process%20in%20Florida%20showing%20different%20stages%20from%20foundation%20to%20completion%2C%20workers%20on%20site%2C%20modern%20residential%20building%20under%20construction%2C%20professional%20documentation%20photography%20with%20construction%20equipment%20and%20materials%20visible&width=1200&height=600&seq=blog-construction-process-1&orientation=landscape',
    conteudo: 'Conteúdo completo do artigo...',
  },
  {
    slug: 'mercado-imobiliario-florida-tendencias',
    titulo: 'Mercado imobiliário da Flórida: tendências para 2025',
    resumo: 'Análise completa do mercado, regiões em alta, valorização esperada e melhores oportunidades de investimento.',
    categoria: 'Mercado imobiliário',
    tempoLeitura: '12 min',
    data: '5 de janeiro de 2025',
    imagem: 'https://readdy.ai/api/search-image?query=Florida%20real%20estate%20market%20analysis%20concept%20with%20modern%20homes%2C%20growth%20charts%20and%20investment%20data%20visualization%2C%20professional%20business%20photography%20showing%20upward%20trends%2C%20luxury%20residential%20properties%20and%20market%20statistics&width=1200&height=600&seq=blog-market-trends-1&orientation=landscape',
    conteudo: 'Conteúdo completo do artigo...',
  },
  {
    slug: 'bastidores-obra-bravia-group',
    titulo: 'Bastidores: como funciona uma obra da Bravia Group',
    resumo: 'Conheça nosso processo interno, controle de qualidade, gestão de prazos e transparência com investidores.',
    categoria: 'Bastidores da obra',
    tempoLeitura: '7 min',
    data: '28 de dezembro de 2024',
    imagem: 'https://readdy.ai/api/search-image?query=Behind%20the%20scenes%20construction%20site%20management%20in%20Florida%2C%20workers%20and%20supervisors%20reviewing%20blueprints%2C%20quality%20control%20inspection%2C%20professional%20construction%20documentation%20showing%20teamwork%20and%20attention%20to%20detail%2C%20organized%20work%20environment&width=1200&height=600&seq=blog-behind-scenes-1&orientation=landscape',
    conteudo: 'Conteúdo completo do artigo...',
  },
  {
    slug: 'guia-investidor-estrangeiro-florida',
    titulo: 'Guia completo para investidores estrangeiros na Flórida',
    resumo: 'Documentação necessária, aspectos legais, tributação e passo a passo para brasileiros investirem em imóveis nos EUA.',
    categoria: 'Dicas para investidores estrangeiros',
    tempoLeitura: '15 min',
    data: '20 de dezembro de 2024',
    imagem: 'https://readdy.ai/api/search-image?query=International%20real%20estate%20investment%20concept%20with%20American%20and%20Brazilian%20flags%2C%20legal%20documents%20and%20contracts%2C%20professional%20business%20setting%20showing%20cross-border%20investment%20process%2C%20modern%20office%20environment%20with%20global%20investment%20theme&width=1200&height=600&seq=blog-foreign-investor-1&orientation=landscape',
    conteudo: 'Conteúdo completo do artigo...',
  },
  {
    slug: 'retorno-investimento-construcao-residencial',
    titulo: 'Retorno sobre investimento em construção residencial',
    resumo: 'Análise detalhada de ROI, comparação com outros investimentos e fatores que influenciam a rentabilidade.',
    categoria: 'Investimento na Flórida',
    tempoLeitura: '9 min',
    data: '15 de dezembro de 2024',
    imagem: 'https://readdy.ai/api/search-image?query=Return%20on%20investment%20concept%20for%20residential%20construction%20with%20financial%20charts%2C%20calculator%20and%20house%20model%2C%20professional%20business%20photography%20showing%20profit%20analysis%20and%20investment%20returns%2C%20modern%20financial%20planning%20visualization&width=1200&height=600&seq=blog-roi-analysis-1&orientation=landscape',
    conteudo: 'Conteúdo completo do artigo...',
  },
];
